export const CATALOG_UPDATE_LAST_READING = 'CATALOG_UPDATE_LAST_READING';
export const CATALOG_UPDATE_LAST_READING_RESULT = 'CATALOG_UPDATE_LAST_READING_RESULT';

export const FLEET_VEHICLE_GET_STATUSES = 'FLEET_VEHICLE_GET_STATUSES';
export const FLEET_VEHICLES_GET_STATUSES_RESULT = 'FLEET_VEHICLES_GET_STATUSES_RESULT';

export const FLEET_MAIN_CHANGE_FILTERS = 'FLEET_MAIN_CHANGE_FILTERS';
